import arabic from './ar';
import english, { type TranslationKeys } from './en';

// Supported locales type
export type Locale = 'en' | 'ar';

// Type helper to make translation values flexible (any string)
// while keeping the structure type-safe
type DeepStringify<T> = {
  [K in keyof T]: T[K] extends object ? DeepStringify<T[K]> : string;
};

// The translation interface allows any string value
// but requires the same structure as English
export type TranslationInterface = DeepStringify<TranslationKeys>;

// All translations keyed by locale
export const translations: Record<Locale, TranslationInterface> = {
  en: english,
  ar: arabic,
};

// Locale configuration
export const locales: Locale[] = ['en', 'ar'];
export const defaultLocale: Locale = 'en';

// Locale display names
export const localeNames: Record<Locale, string> = {
  en: 'English',
  ar: 'العربية',
};

// RTL languages
export const rtlLocales: Locale[] = ['ar'];

// Check if a locale is RTL
export function isRTL(locale: Locale): boolean {
  return rtlLocales.includes(locale);
}

// Validate if a string is a valid locale
export function isValidLocale(locale: string): locale is Locale {
  return locales.includes(locale as Locale);
}

// Get translation for a locale
export function getTranslation(locale: Locale): TranslationInterface {
  return translations[locale] || translations[defaultLocale];
}

export { english, arabic };
